// Maps a route pathname to the human-readable German view title (used for the
// document title and for frontend-usage tracking payloads).

export function normalizePathname(pathname) {
  if (!pathname) return '/';
  const trimmed = String(pathname).trim();
  if (!trimmed) return '/';
  if (trimmed.length > 1 && trimmed.endsWith('/')) return trimmed.slice(0, -1);
  return trimmed;
}

export function resolveViewTitle({ pathname, menuItems }) {
  const normalizedPath = normalizePathname(pathname);

  // Views that are not necessarily represented in the sidebar menu.
  const fallbackTitles = {
    '/': 'Login',
    '/login': 'Login',
    '/rfid-login': 'RFID Login',
    '/request-password-reset': 'Passwort zurücksetzen',
    '/reset-password': 'Passwort zurücksetzen',
    '/bookingSearch': 'Buchungssuche',
    '/mailTemplateEditor': 'Mailvorlage bearbeiten',
    '/switch-identity': 'Identität wechseln',
  };

  if (fallbackTitles[normalizedPath]) return fallbackTitles[normalizedPath];

  const items = Array.isArray(menuItems) ? menuItems : [];
  const match = items.find(i => !i?.isExternal && normalizePathname(i?.link) === normalizedPath);
  if (match?.name) return match.name;

  // Prefer a short, user-friendly title for the most frequented view.
  if (normalizedPath === '/bookings') return 'Buchungen';

  return null;
}
